import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["userSelect", "contactSelect"]

  connect() {
    this.toggleTomSelectState("contact", false)
  }

  toggleType(event) {
    const isUser = event.target.value === "User"

    if (isUser) {
      this.userSelectTarget.classList.remove("hidden")
      this.toggleTomSelectState("user", true)

      this.contactSelectTarget.classList.add("hidden")
      this.toggleTomSelectState("contact", false)
    } else {
      this.userSelectTarget.classList.add("hidden")
      this.toggleTomSelectState("user", false)

      this.contactSelectTarget.classList.remove("hidden")
      this.toggleTomSelectState("contact", true)
    }
  }

  toggleTomSelectState(type, shouldEnable) {
    const selectElement = document.getElementById(`${type}_tom_select`)
    if (!selectElement) return

    const tsInstance = selectElement.tomselect

    if (tsInstance) {
      if (shouldEnable) {
        tsInstance.enable()
      } else {
        tsInstance.clear()
        tsInstance.disable()
      }
    } else {
      selectElement.disabled = !shouldEnable
    }
  }
}
